import { render, staticRenderFns } from "./SinglePaneDocument.vue?vue&type=template&id=55f4ae84&scoped=true&"
import script from "./SinglePaneDocument.vue?vue&type=script&lang=ts&"
export * from "./SinglePaneDocument.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePaneDocument.vue?vue&type=style&index=0&id=55f4ae84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4ae84",
  null
  
)

export default component.exports